import {useTranslation} from 'react-i18next';
import React from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblem';
import {ExpandMore} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Collapse, Paper} from '@mui/material';
import * as moment from 'moment/moment';
import config from '../../../../app/config';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {useAlarmsStyles} from './patientAlarms';
import * as PropTypes from 'prop-types';
import MessageBox from '../../../../util/messageBox';
import useOpenState from '../../../../hooks/useOpenState';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import {AlarmStage} from '../../mainScreen/alarmStage';

const GroupedAlarms = (props) => {
    const classes = useAlarmsStyles();
    const {t} = useTranslation();
    const [expanded, setExpanded] = React.useState(props.acknowledge);
    const [isConfirmDeleteOpen, openConfirmDelete, closeConfirmDelete] = useOpenState(false, true);

    const [alarmToDelete, setAlarmToDelete] = React.useState(null);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleCloseDialog = () => {
        setAlarmToDelete(null);
        closeConfirmDelete();
    };

    const handleDeleteAlarm = () => {
        props.deleteAlarm(alarmToDelete);
        handleCloseDialog();
    };

    return (
        <div className={classes.alertGroup}>
            <div className={classes.alertGroupName} onClick={handleExpandClick}>
                {/*<div className={classes.blockColor} style={{background: props.groupColor}}/>*/}
                <div className={classes.blockColor}/>
                <ReportProblemOutlinedIcon className={classes.alertGroupNameIco}/>
                <div className={classes.alertGroupNameText}>
                    {props.groupName}
                </div>

                <div className={classes.alarmGroupBadge}>
                    {props.alarms.length}
                </div>

                <div className={classes.alarmGroupExpandBtn}>
                    <ExpandMore
                        aria-expanded={expanded}
                        aria-label={t('show more')}
                    >
                        <ExpandMoreIcon/>
                    </ExpandMore>
                </div>
            </div>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                {props.alarms?.map(alarm => (
                        <Paper key={'alarm-block-' + alarm.id} className={classes.alertAlarm}>
                            <Grid item xs={12} className={classes.divRow}>
                                <FormLabel className={classes.label}>
                                    {alarm.name}
                                </FormLabel>
                                <div className={classes.divRow} style={{marginLeft: 'auto'}}>
                                    <div>
                                        {moment(alarm.expireDate).isBefore(moment()) ? t('Expired at') : t('Expires')}: {moment(alarm.expireDate).format(config.defaultDateTimeFormat)}
                                    </div>
                                    {!props.acknowledge &&
                                        <IconButton
                                            disableRipple
                                            onClick={() => {
                                                setAlarmToDelete(alarm);
                                                openConfirmDelete();
                                            }}
                                        >
                                            <DeleteForeverIcon/>
                                        </IconButton>
                                    }
                                </div>
                            </Grid>

                            <Grid item xs={12}>
                                <div className={classes.divRow}>
                                    <FormLabel className={classes.label} style={{marginRight: 5}}>
                                        {t('Description')}:&nbsp;{alarm.description || '-'}
                                    </FormLabel>

                                    <div style={{marginLeft: 'auto'}}>
                                        {moment(alarm.expireDate).isSameOrAfter(moment()) &&
                                            <FormLabel className={classes.label} style={{marginRight: 5}}>
                                                {t('Banner Info')}:&nbsp;<strong>{alarm.onBanner ? t('[Risk/Priority]: ') + AlarmStage.AlarmStageName(alarm.stage) : t('Banner information off')}</strong>
                                            </FormLabel>
                                        }
                                    </div>
                                </div>

                                {props.groupAdditionalDesc &&
                                    <div>
                                        <FormLabel className={classes.label} style={{marginRight: 5}}>
                                            {t('Additional Description')}
                                        </FormLabel>
                                        {props.groupAdditionalDesc || '-'}
                                    </div>
                                }
                            </Grid>

                            <Grid item xs={12}>
                                <div className={classes.divRow}>
                                    <FormLabel className={classes.label} style={{marginRight: 5}}>
                                        {t('Created by')}: <b>{` ${alarm.userAdd || 'UNK'}`}</b>
                                    </FormLabel>

                                    <div style={{marginLeft: 'auto'}}>
                                        <FormLabel className={classes.label} style={{marginRight: 5}}>
                                            {t('Created at')}: <b>{` ${moment(alarm.dateAdd).format(config.defaultDateTimeFormat)}`}</b>
                                        </FormLabel>
                                    </div>
                                </div>
                            </Grid>
                        </Paper>
                    ),
                )}
            </Collapse>

            <MessageBox
                open={isConfirmDeleteOpen}
                onClose={handleCloseDialog}
                title={t('Confirmation')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={handleDeleteAlarm}
                message={t('Are you sure you want to delete this patient alarm?')}
                fullWidth
                warning
            />
        </div>
    );
};

GroupedAlarms.propTypes = {
    deleteAlarm: PropTypes.func,
    groupAdditionalDesc: PropTypes.any,
    alarms: PropTypes.any,
};

export default GroupedAlarms;